module.exports = __webpack_public_path__ + "img/my-scenarios-fill.4b5eeb7e.svg";